export default __webpack_public_path__ + "static/media/teacher_pic2.ffc8d056.jpg";